import { PublicClientApplication, AccountInfo } from '@azure/msal-browser';
import { loginRequest } from '@/config/authConfig';

/**
 * Securely acquires access token using MSAL
 * Eliminates need for manual sessionStorage management
 */
export class TokenService {
  private msalInstance: PublicClientApplication;

  constructor(msalInstance: PublicClientApplication) {
    this.msalInstance = msalInstance;
  }

  /**
   * Get access token for API calls
   * MSAL automatically handles caching and refresh
   */
  async getAccessToken(): Promise<string | null> {
    const accounts = this.msalInstance.getAllAccounts();
    
    if (accounts.length === 0) {
      console.warn('⚠️ No accounts found. User needs to login.');
      return null;
    }

    const account: AccountInfo = accounts[0];

    try {
      // MSAL handles token caching and automatic refresh
      const response = await this.msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account,
      });

      // Validate token is a string before returning
      if (typeof response.accessToken === 'string' && response.accessToken.length > 0) {
        // Validate JWT format (should have 3 parts separated by dots)
        const parts = response.accessToken.split('.');
        if (parts.length === 3) {
        
          return response.accessToken;
        } else {
          
          return null;
        }
      } else {
       
        return null;
      }
    } catch (error) {
      
      
      // Token acquisition failed - user needs to re-authenticate
      return null;
    }
  }

  /**
   * Check if user is authenticated
   */
  isAuthenticated(): boolean {
    return this.msalInstance.getAllAccounts().length > 0;
  }

  /**
   * Get current account info
   */
  getAccount(): AccountInfo | null {
    const accounts = this.msalInstance.getAllAccounts();
    return accounts.length > 0 ? accounts[0] : null;
  }
}
